import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

class OrderService {
    listOrders(locationId, limit, page, filters = {}){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/order/listOrders' + '?merchant=' + user.merchant + '&locationId=' + locationId + '&limit=' + limit + '&page=' + page;
        if (filters.searchQuery) url += '&searchQuery=' + encodeURIComponent(filters.searchQuery);
        if (filters.channel) url += '&channel=' + encodeURIComponent(filters.channel);
        if (filters.orderType) url += '&orderType=' + encodeURIComponent(filters.orderType);
        if (filters.orderStatus) url += '&orderStatus=' + encodeURIComponent(filters.orderStatus);
        if (filters.paymentStatus) url += '&paymentStatus=' + encodeURIComponent(filters.paymentStatus);
        if (filters.dateFrom) url += '&dateFrom=' + encodeURIComponent(filters.dateFrom);
        if (filters.dateTo) url += '&dateTo=' + encodeURIComponent(filters.dateTo);
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getOrder(orderDocumentId){
        let url = '/api/order/getOrder' + '?orderDocumentId=' + orderDocumentId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    getDataForOrderDetailGui(orderDocumentId){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/order/getDataForOrderDetailGui' + '?merchant=' + user.merchant + '&orderDocumentId=' + orderDocumentId;
        let basicAuth = authHeader();
        return axios.get(url, { headers: basicAuth });
    }

    sendReceipt(orderDocumentId, email){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/order/sendReceipt';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                merchant: user.merchant, //Required by the security check (cross-merchant protection)
                orderDocumentId: orderDocumentId,
                email: email
            },
            {headers: basicAuth}
        );
    }

    updateOrderStatus(orderDocumentId, orderStatus){
        //let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/order/updateOrderStatusFromBackOffice';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                orderDocumentId: orderDocumentId,
                orderStatus: orderStatus
            },
            {headers: basicAuth}
        );
    }

    repairOrderData(orderDocumentId, repairedBody){
        let url = '/api/order/repairOrderData';
        let basicAuth = authHeader();
        return axios.post(url,
            {
                orderDocumentId: orderDocumentId,
                repairedBody: repairedBody
            },
            {headers: basicAuth}
        );
    }
}

export default new OrderService();
